import React from 'react';
import SonyLogo from '../../images/sony-logo-vector.png';
import './Logo.css';
import { NavbarBrand } from 'reactstrap';

const Logo = () => {
	return (
		<div>
			<div className='Logo'>
				<NavbarBrand href='/'>
					<div className='Logo__typo'>
						<img className='Logo__Sony' src={SonyLogo} alt='Sony Logo' />
					</div>
				</NavbarBrand>
			</div>
		</div>
	);
};

export default Logo;
